"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Image from "next/image";
import { Button } from "@/components/ui/button";
import { setCookieByName } from "@/lib/cookies";
import {
  supportedLanguagesFromCountries,
  supportedLanguages,
  type SupportedLanguage,
} from "@/lib/shared";
import { ArrowDown2 } from "iconsax-react";
import { usePathname } from "next/navigation";
import { localizedPath, pathWithoutLocale } from "@/lib/localePath";
import { NEXT_LOCALE_COOKIE, resolveLocale } from "@/lib/resolvedLocale";

export default function SelectLanguage() {
  const pathname = usePathname();
  const splittedPath = pathname.split("/").filter(Boolean);
  const first = splittedPath[0];
  const langFromPath =
    first && supportedLanguages.includes(first as SupportedLanguage)
      ? first
      : resolveLocale(undefined);

  const selectedLanguage = supportedLanguagesFromCountries.find(
    (country) => country.language === langFromPath,
  );

  const createLanguageUrl = (newLang: string): string => {
    const lang = newLang as SupportedLanguage;
    if (!supportedLanguages.includes(lang)) {
      return pathname;
    }
    const restPath = pathWithoutLocale(pathname);
    if (restPath === "/" || restPath === "") {
      return `/${lang}`;
    }
    return localizedPath(lang, restPath);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="xl" rounded="full" className="!px-2">
          {selectedLanguage?.imageCircle && (
            <>
              <Image
                src={selectedLanguage.imageCircle}
                width={32}
                height={32}
                alt={selectedLanguage.name || ""}
              />
              {/* <span className="">{selectedLanguage.name}</span> */}
            </>
          )}
          <ArrowDown2 className="fill-primary " size="24" variant="Outline" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[150px]">
        {supportedLanguagesFromCountries.map((country) => (
          <DropdownMenuItem
            key={country.language}
            className="cursor-pointer"
            asChild
          >
            <button
              className="w-full"
              onClick={async () => {
                await setCookieByName(NEXT_LOCALE_COOKIE, country.language);
                window.location.href = createLanguageUrl(country.language);
              }}
            >
              {country.imageCircle && (
                <Image
                  src={country.imageCircle}
                  width={24}
                  height={24}
                  alt={country.name || ""}
                />
              )}
              {country.name}
            </button>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
